import { useState, useCallback } from 'react';
import { clampToViewport } from '@/lib/clampRect';

const KX = 'trackizy_livemap_replay_player_x';
const KY = 'trackizy_livemap_replay_player_y';
const KW = 'trackizy_livemap_replay_player_w';
const KH = 'trackizy_livemap_replay_player_h';
const DEFAULT_W = 344;
const DEFAULT_H = 460;
const MIN_W = 300;
const MIN_H = 240;

function num(key) {
  try { const v = Number(localStorage.getItem(key)); return Number.isFinite(v) && v !== 0 ? v : null; } catch { return null; }
}

function readInitial() {
  const vw = typeof window !== 'undefined' ? window.innerWidth : 1200;
  const vh = typeof window !== 'undefined' ? window.innerHeight : 800;
  const width = Math.max(MIN_W, num(KW) ?? DEFAULT_W);
  const height = Math.max(MIN_H, num(KH) ?? DEFAULT_H);
  const rawX = num(KX) ?? Math.max(20, vw - width - 22); // default top-right
  const rawY = num(KY) ?? 76;                            // below the glass top bar
  // Clamp the persisted position so a card saved off-screen (smaller window or
  // a different device) always reopens with its grip reachable.
  const { x, y } = clampToViewport({ x: rawX, y: rawY, w: width, h: height, vw, vh });
  return { x, y, width, height };
}

/**
 * Per-user position + size of the floating Trip Player. Single consumer
 * (ReplayTripPlayer), so per-instance useState + localStorage is sufficient.
 */
export function useReplayPlayerLayout() {
  const [layout, setLayout] = useState(readInitial);

  const setPos = useCallback(({ x, y }) => {
    setLayout((prev) => {
      const next = { ...prev, x, y };
      try { localStorage.setItem(KX, String(x)); localStorage.setItem(KY, String(y)); } catch { /* ignore */ }
      return next;
    });
  }, []);

  const setSize = useCallback(({ width, height }) => {
    setLayout((prev) => {
      const next = { ...prev, width, height };
      try { localStorage.setItem(KW, String(width)); localStorage.setItem(KH, String(height)); } catch { /* ignore */ }
      return next;
    });
  }, []);

  return { ...layout, minW: MIN_W, minH: MIN_H, setPos, setSize };
}
